import { TranslateFunction } from '@dreryk/react-common';

import { PatientMedicalInformationRemoveFormBean } from '../PatientMedicalInformationRemoveForm.types';
import { translationKeys } from '../../translations';

export const getDescription = (
   parameters: PatientMedicalInformationRemoveFormBean,
   translate: TranslateFunction
): string => {
   if (parameters.description) {
      return parameters.description;
   }

   return translate(translationKeys.reasonMap[parameters.reason]);
};
